exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brand-logo {\n  height: 100%;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n  .brand-logo img {\n    max-height: 70%;\n    image-rendering: -webkit-optimize-contrast; }\n\n.btn-logout {\n  color: #ff6060 !important;\n  font-size: 20px;\n  border-color: #ff6060; }\n\n.nav-wrapper.oldyear {\n  background-image: linear-gradient(to right, #e5232c 0%, #51c6ea 100%); }\n\n.nav-wrapper.test {\n  background-image: linear-gradient(to right, #e5232c 0%, #dbea51 100%); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/eveasoft/lea/lea-front/src/app/core/layout/header/header.component.scss
// module id = ../../../../../src/app/core/layout/header/header.component.scss
// module chunks = main